module.exports = __webpack_public_path__ + "static/img/pexels-naim-benjelloun-2291367.9547f08.jpg";